// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#137ede","subMenuActiveText":"#137ede","menuBg":"#137ede","menuHover":"#fff","subMenuBg":"#137ede","subMenuHover":"#fff","sideBarWidth":"150px"};


//////////////////
// WEBPACK FOOTER
// ./src/user/styles/index.scss
// module id = e5kn
// module chunks = 12